module.exports = __webpack_public_path__ + "static/media/icon-estudios.6f4f27ce.svg";